/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ company: NonNullable<unknown> }} Login_Invitation_BannerInputs */

const es_co2_login_invitation_banner = /** @type {(inputs: Login_Invitation_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inicia sesión para unirte a ${i?.company}.`)
};

/**

* @param {Login_Invitation_BannerInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const login_invitation_banner = /** @type {((inputs: Login_Invitation_BannerInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Invitation_BannerInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_login_invitation_banner(inputs)
});